import React from 'react';

import { LocalizableText } from '~/@components/LocalizableText';
import { useUserRules } from '~/@store/permissions';

import { PermissionsTable } from './PermissionsTable';

export const UserPermissions = () => {
    const rules = useUserRules();
    const extendedColumns = [
        {
            field: 'subject' as const,
            title: <LocalizableText code={'PermissionsPage.subject'} />,
        },
    ];

    return (
        <PermissionsTable
            title={<LocalizableText code={'PermissionsPage.user'} />}
            rules={rules}
            extendedColumns={extendedColumns}
        />
    );
};
